export default __webpack_public_path__ + "static/media/FKGroteskNeue-Regular.a1f7cc11.otf";